<template>

  <div class="attachment-list d-flex flex-wrap">

    <div
      v-for="attachment in attachments"
      :key="attachment.id"
      class="attachment-list-item d-flex align-items-center border rounded px-2 py-1 mr-2 mb-2">

      <!-- a recording can be listened to before going out -->
      <audio
        v-if="attachment.url"
        class="attachment-list-player mr-2"
        :src="attachment.url"
        controls></audio>

      <template v-else>
        <i
          :class="icon(attachment)"
          class="text-muted mr-2"></i>
        <div class="attachment-list-info mr-2">
          <div class="attachment-list-name text-truncate">{{ attachment.name }}</div>
          <div class="small text-muted">{{ size(attachment) }}</div>
        </div>
      </template>

      <button
        type="button"
        class="btn btn-link btn-sm text-muted p-0"
        :title="$t('Remove')"
        :disabled="disabled"
        @click="$emit('remove', attachment.id)">
        <i class="fa-solid fa-xmark"></i>
      </button>

    </div>

  </div>

</template>

<script>
// message type -> icon shown while the attachment is still pending
const TYPE_ICONS = {
  image: 'fa-regular fa-image',
  video: 'fa-solid fa-video',
  audio: 'fa-regular fa-file-audio',
  document: 'fa-regular fa-file-lines'
}

export default {
  name: 'AttachmentList',
  props: {
    /*
    files waiting to be sent: { id, name, size, type } and, for a recording,
    an url so it can be played. nothing here is uploaded yet
    */
    attachments: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /*
    icon
    */
    icon (attachment) {
      return TYPE_ICONS[attachment.type] || TYPE_ICONS.document
    },
    /*
    size
    */
    size (attachment) {
      const kilobytes = (attachment.size || 0) / 1024

      if (kilobytes < 1024) {
        return Math.max(1, Math.round(kilobytes)) + ' KB'
      }

      return (kilobytes / 1024).toFixed(1) + ' MB'
    }
  }
}
</script>

<style scoped>
.attachment-list-item {
  background: #f8f9fa;
  max-width: 100%;
}

/* the name is elided instead of stretching the chip across the composer */
.attachment-list-info {
  min-width: 0;
  max-width: 180px;
}

.attachment-list-name {
  font-size: 13px;
}

.attachment-list-player {
  height: 32px;
  max-width: 220px;
}

.attachment-list .btn-link:hover:not(:disabled) {
  color: #2b8aef !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/composer/AttachmentList.vue